var React = require('react');

function ChevronDownGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 5.05247L8.75796 4L5.52171 6.86952L2.21382 4.06266L1 5.14059L5.55056 9L10 5.05247Z","fill":"#858585"}));
}

ChevronDownGrey.defaultProps = {"width":"11","height":"12","viewBox":"0 0 11 12","fill":"none"};

module.exports = ChevronDownGrey;

ChevronDownGrey.default = ChevronDownGrey;
